import axios from 'axios'
import { Message } from 'element-ui'
// 注意：不在顶层 import store，避免循环依赖链：
//   store/index.js → api/warehouse.js → utils/request.js
// 拦截器直接从 localStorage 读取 currentWarehouseId，
// 与 store 的 SET_CURRENT_WAREHOUSE mutation 保持同步。

const request = axios.create({
    baseURL: '',
    timeout: 10000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = 'Bearer ' + token
  }

  // 全局仓库选择器：自动注入 warehouseId
  // 排除移库和仓库管理 API
  const url = config.url || ''
  const excludeApis = ['/api/wms/move/', '/api/wms/warehouse/', '/api/wms/inbound-order/production/pending']
  const shouldAddWarehouse = !excludeApis.some(api => url.includes(api))

  if (shouldAddWarehouse) {
    const warehouseId = localStorage.getItem('currentWarehouseId')
    if (warehouseId) {
      if (config.method === 'get') {
        config.params = config.params ? { ...config.params, warehouseId } : { warehouseId }
      } else if (config.method === 'post' || config.method === 'put') {
        // 仅对普通对象注入 warehouseId；FormData 和数组跳过，避免破坏上传数据
        if (config.data && !Array.isArray(config.data) && !(config.data instanceof FormData) && typeof config.data === 'object') {
          config.data = { ...config.data, warehouseId }
        }
      }
    }
  }

  return config
})

request.interceptors.response.use(
    response => {
        // blob 类型（导出文件）直接返回原始数据，不做 JSON 解析
        if (response.config.responseType === 'blob') {
            return response.data
        }
        const res = response.data
        if (res.code !== 200) {
            Message.error(res.message || '错误')
            return Promise.reject(new Error(res.message || 'Error'))
        }
        return res.data
    },
    error => {
        const status = error.response && error.response.status
        if (status === 401) {
            // 任务1(0910)：401 统一处理——清 token + 一次性整页跳登录。
            // 用 location.href 而非 router：① request.js 处于循环依赖敏感区（不可顶层 import router）
            // ② 整页刷新天然销毁所有残留定时器/事件监听；__redirecting401 防并发多请求重复提示跳转。
            localStorage.removeItem('token')
            if (!window.__redirecting401) {
                window.__redirecting401 = true
                Message.error('登录已过期，请重新登录')
                const back = encodeURIComponent(window.location.pathname + window.location.search)
                setTimeout(() => {
                    window.location.href = '/login' + (window.location.pathname === '/login' ? '' : (back ? '?redirect=' + back : ''))
                }, 300)
            }
            return Promise.reject(error)
        }
        Message.error(error.message || '网络错误')
        return Promise.reject(error)
    }
)

export default request
